import { watchMooodboardMediaDelete } from './delete'
import { watchMoodboardMediaUpload } from './upload'

export const moodboardSagas = [watchMoodboardMediaUpload, watchMooodboardMediaDelete]
